module.exports = __webpack_public_path__ + "static/media/pinDefault.edb28984.svg";